import { BaseReactiveClass } from 'Classes/BaseReactiveClass';

export class ModelAccountCustodianItem extends BaseReactiveClass {
  constructor({ name, website }) {
    if (!name || !website) throw new Error('ModelAccountCustodianItem required name and website');
    super({ name, website });
  }
}
